import React, { ReactNode } from 'react';

type PropTypes = {
  children: string | ReactNode;
};

export default function ProfilePageSectionDescription(props: PropTypes) {
  return <p className="w-full ev-sm:w-8/12 pb-8 ev-sm:pb-10 m-0 text-ev-navy-blue">{props.children}</p>;
}
